__webpack_require__.p = "/react-widget/public/";